import axios from 'axios';

export default axios.create({
  // baseURL: `http://localhost:80/apiCursos/routes`,
  baseURL: `https://apidemo.ciomprix.com/routes`,
  /* baseURL: `https://api.bancoppolis.com.mx/routes`, */
  timeout: 20000,
  /* headers: {'Access-Control-Allow-Origin': '*'} */
});